<template>
    <div class="select2-block" v-click-outside="() => show = false" ref="Select">
        <span :class="['select2 select2-container', disabled ? 'select2-container--disabled' : '']"  @click="show = !show, $emit('focus')">
            <span class="selection">
                <span class="select2-selection select2-selection--single">
                    <span class="select2-selection__rendered">
                        <span>{{ selectedValue }}</span>
                    </span>
                    <span class="select2-selection__arrow"></span>
                </span>
            </span>
        </span>
        <span class="select2-results" v-if="show && !disabled">
            <ul class="select2-results__options">
                <SelectOption
                    v-for="option in selectorOptions"
                    :seleted="option.key === modelValue"
                    :text="option.value"
                    @click="$emit('update:modelValue', option.key), show = false"
                />
            </ul>
        </span>
    </div>
</template>
<script>
import vClickOutside from 'click-outside-vue3'
import SelectOption from './SelectOption.vue'
export default {
    name: "Select",
    components: {
        SelectOption
    },
    props: {
        modelValue: {
            type: [String, Number],
            default: null
        },
        optionKey: {
            type: String,
            required: true
        },
        optionValue: {
            type: String,
            required: true
        },
        emptyValue: {
            type: String,
            default: null
        },
        options: {
            type: Array,
            default: () => []
        },
        placeholder: {
            type: String,
            default: () => translate('components.select.default_placeholder')
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    emits: ['update:modelValue', 'focus', 'blur'],
    data() {
        return {
            show: false
        }
    },
    watch: {
        show(newValue, oldValue) {
            if (oldValue) {
                this.$emit('blur')
            }
        }
    },
    computed: {
        selectorOptions() {
            let options = []

            this.options.map(option => {
                options.push({
                    key: option[this.optionKey],
                    value: option[this.optionValue]
                })
            })

            if (this.emptyValue) {
                options.unshift({
                    key: null,
                    value: this.emptyValue
                })
            }

            return options
        },
        selectedValue() {
            return this.selectorOptions.filter((item) => item.key === this.modelValue)[0]?.value ?? this.placeholder
        }
    },
    directives: {
      clickOutside: vClickOutside.directive
    }
}
</script>
<style scoped>
.select2-block {
    position: relative;
    flex: 1
}
.select2 {
    width: 100%;
}
.select2-results {
    position: absolute;
    width: 100%;
    background: white;
    border-radius: 3px;
    border: 1px solid rgba(0,0,0,.15);
    z-index: 9999;
}
.select2-results__option:hover {
    background: #f5f5f5;
}
.select2-results__option[aria-selected=true]:hover {
    background: #26a69a;
}
</style>
